import { useState, useEffect } from "react";
import { BASE_URL } from "../env";
import { useHistory } from "react-router-dom";
import { Table } from "react-bootstrap";
import { Fab } from "@mui/material";
import { Edit, Visibility } from "@mui/icons-material";
import {
	useReactTable,
	createColumnHelper,
	getCoreRowModel,
	flexRender,
} from "@tanstack/react-table";

type Questions = {
	name: string;
	outOfScore: number;
	questionWeigh: string;
	category: string;
	_id: string;
};

const columnHelper = createColumnHelper<Questions>();

function renderLevel(val: string) {
	let level = parseInt(val);
	if (isNaN(level)) return "Error";
	else {
		if (level <= 2) return "Easy";
		else if (level <= 4) return "Medium";
		else return "Hard";
	}
}

const columns = [
	columnHelper.accessor((val) => val.name, {
		id: "name",
		cell: (info) => <div>{info.getValue()}</div>,
		header: "Question Name",
		footer: (info) => info.column.id,
	}),
	columnHelper.accessor((val) => `${val.outOfScore}`, {
		cell: (info) => <div>{info.getValue()}</div>,
		header: "Out Of Score",
		footer: (info) => info.column.id,
	}),
	columnHelper.accessor((val) => val.category, {
		cell: (info) => <div>{info.getValue()}</div>,
		header: "Category",
		footer: (info) => info.column.id,
	}),
	columnHelper.accessor((val) => val.questionWeigh, {
		cell: (info) => <div>{renderLevel(info.getValue())}</div>,
		header: "Question Level",
		footer: (info) => info.column.id,
	}),
];

const QuizScore = () => {
	const [data, setData] = useState<Questions[]>(() => []);
	const history = useHistory();
	const table = useReactTable({
		data,
		columns,
		getCoreRowModel: getCoreRowModel(),
	});

	useEffect(() => {
		fetch(BASE_URL + "/GetAllQuestionAdmin")
			.then((res) => res.json())
			.then((data) => {
				setData(data.questions);
			});
	}, []);

	const numberStyle = {
		border: "2px solid black",
		boxShadow: "4px 4px rgba(93, 93, 93)",
		borderRadius: "20px",
		fontFamily: "Poppins-Bold",
		color: "white",
	};

	function handleEditClick(index: number) {
		history.push(`/coding-edit/${data[index]._id}`);
	}

	function handleViewClick(index: number) {
		window.open(
			`https://www.cantileverlabs.com/compiler/${data[index]._id}/16`,
			"_blank"
		);
	}

	return (
		<>
			<div className="text-centre my-4">
				<h1
					style={{
						fontFamily: "Poppins-Bold",
						color: "#185adb",
						textAlign: "center",
					}}
				>
					<span style={{ color: "black" }}>All Questions </span>
				</h1>
			</div>

			<div className="mx-2 w-25 p-3 bg-dark " style={numberStyle}>
				Row Count:<span style={{ color: "yellow" }}>{data.length}</span>
			</div>
			<div className="text-center my-3">
				<Table>
					<thead className="bg-sky-500">
						{table.getHeaderGroups().map((headerGroup) => (
							<tr key={headerGroup.id}>
								{headerGroup.headers.map((header) => (
									<th
										key={header.id}
										className="border-2 border-sky-500"
									>
										{header.isPlaceholder
											? null
											: flexRender(
													header.column.columnDef
														.header,
													header.getContext()
											  )}
									</th>
								))}
								<th className="border-2 border-sky-500">
									Options
								</th>
							</tr>
						))}
					</thead>

					<tbody>
						{table.getRowModel().rows.map((row, index) => (
							<tr
								key={row.id}
								className="cursor-pointer hover:bg-slate-200 transition-all"
								// onClick={() => handleRowClick(index)}
							>
								{row.getVisibleCells().map((cell) => (
									<td
										key={cell.id}
										className="py-2 border-2 border-black"
									>
										{flexRender(
											cell.column.columnDef.cell,
											cell.getContext()
										)}
									</td>
								))}
								<td className="py-2 border-2 border-black flex gap-2">
									<Fab
										size="small"
										color="info"
										onClick={() => handleEditClick(index)}
									>
										<Edit />
									</Fab>
									<Fab
										size="small"
										color="info"
										onClick={() => handleViewClick(index)}
									>
										<Visibility />
									</Fab>
								</td>
							</tr>
						))}
					</tbody>
				</Table>
			</div>
		</>
	);
};

export default QuizScore;
